/**
 * The emoji-distribution chart palette (SIMS-9053).
 *
 * Index order is the contract: the backend emits its value list with the BEST
 * rating first, so index 0 is Good, 1 is Fair/Neutral, 2 is Poor/Low. Those
 * three are the colours specified on SIMS-9053:
 *
 *   Good          Teal    #1D9E75
 *   Fair/Neutral  Amber   #EF9F27
 *   Poor/Low      Coral   #D85A30
 *
 * Indices 3 and 4 exist for rating scales with more than three steps; they
 * carry no Good/Fair/Poor meaning and are only there so a 4- or 5-point scale
 * does not wrap around and reuse teal for its worst value.
 *
 * Named here rather than inline in the chart so the index-to-meaning mapping
 * has somewhere to live — it is the reason the order cannot be shuffled, and
 * IndependentRatingsView.test.tsx asserts it.
 *
 * Note this amber is #EF9F27, per the ticket. The rest of the app uses
 * #F2A93B (EngagementRateBadge, AccessRateChart); the two are deliberately not
 * unified here, since SIMS-9053 scoped the change to this chart.
 */
export const EMOJI_TONES = [
	"#1D9E75",
	"#EF9F27",
	"#D85A30",
	"#7F77DD",
	"#3683C2",
] as const;
